import * as React from 'react';

import { Alert, Box, Chip, LinearProgress, Typography } from '@mui/material';

import styles from '../ReportRequestV2.module.css';

interface Props {
  title: string;
  subtitle: string;
  /** Project name of the report this form was prefilled from. */
  templateName?: string;
  showTemplateNotice: boolean;
  resolvingTemplate: boolean;
  parentMissing: boolean;
  /** Rendered at the right of the title, e.g. a toggle. */
  actions?: React.ReactNode;
}

const FormHeader: React.FC<Props> = ({
  title,
  subtitle,
  templateName,
  showTemplateNotice,
  resolvingTemplate,
  parentMissing,
  actions,
}) => (
  <>
    <Box className={styles.header}>
      <Box>
        <Typography variant="h4" component="h1" className={styles.title}>
          {title}
          <Chip
            label="V2 beta"
            size="small"
            color="secondary"
            variant="outlined"
          />
        </Typography>
        <Typography color="text.secondary">{subtitle}</Typography>
      </Box>
      {actions}
    </Box>
    {resolvingTemplate && (
      <LinearProgress aria-label="Loading the template report" />
    )}
    {showTemplateNotice && templateName !== undefined && (
      <Alert severity="info">
        Prefilled from “{templateName}”. Review each section before submitting.
      </Alert>
    )}
    {parentMissing && (
      <Alert severity="warning">
        The template’s parent report could not be found. Choose a parent report.
      </Alert>
    )}
  </>
);

export default FormHeader;
